import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import getCardCategoriesQuery from '../../../../../graphql/queries/getCardCategories';
import CustomControl from '../../../../../../../components/global/CustomControl';
import Button from '../../../../../../../components/global/Button';
import CardCategoryEdit from '../CardCategoryEdit';

const propTypes = {
  className: PropTypes.string,
  cardCategories: PropTypes.shape({
    total: PropTypes.number,
    records: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
  onCategorySelect: PropTypes.func.isRequired,
  selectedCategories: PropTypes.array.isRequired,
};

const CardCategories = ({
  className,
  cardCategories,
  selectedCategories,
  onCategorySelect,
}) => {
  const [cardCategoryId, setCardCategoryId] = useState(null);

  const classes = classNames({
    'card-create-category-grid': true,
    [className]: !!className,
  });

  if (!cardCategories) {
    return null;
  }

  const cardCategoryEdit = cardCategories.records.find(
    x => x.id === cardCategoryId,
  );

  return (
    <div className={classes}>
      {cardCategories.records.map(cardCategory => {
        const checked = selectedCategories.find(c => c.id === cardCategory.id);

        return (
          <div className="d-flex align-items-center">
            <CustomControl
              id={`${cardCategory.id}-category`}
              type="checkbox"
              label={cardCategory.name}
              className="m-1"
              checked={checked}
              onChange={() => onCategorySelect(cardCategory)}
            />

            <Button
              btnSize="xs"
              btnStyle="link"
              className="ml-1"
              onClick={() => {
                setCardCategoryId(cardCategory.id);
              }}
            >
              Edit
            </Button>
          </div>
        );
      })}

      {cardCategoryEdit && (
        <div className="mt-2">
          <CardCategoryEdit
            key={cardCategoryEdit.id}
            cardCategory={cardCategoryEdit}
          />
        </div>
      )}
    </div>
  );
};

CardCategories.propTypes = propTypes;

const withCardCategories = graphql(getCardCategoriesQuery, {
  props: ({ data: { cardCategories } }) => ({
    cardCategories,
  }),
});

export default compose(withCardCategories)(CardCategories);
